const STANDARD_HIGHLIGHT = /^\[([^\[\]]+)\]$/;
const LEGACY_HIGHLIGHT = /^(?:【([^【】]+)】|（([^（）]+)）)$/;

export const splitHighlightedText = (value, { includeLegacy = false } = {}) => {
  const source = String(value || '');
  const pattern = includeLegacy
    ? /(\[[^\[\]]+\]|【[^【】]+】|（[^（）]+）)/g
    : /(\[[^\[\]]+\])/g;

  return source.split(pattern).filter(Boolean).map((part) => {
    const standard = part.match(STANDARD_HIGHLIGHT);
    if (standard) return { text: standard[1], highlighted: true };

    if (includeLegacy) {
      const legacy = part.match(LEGACY_HIGHLIGHT);
      if (legacy) return { text: legacy[1] || legacy[2], highlighted: true };
    }

    return { text: part, highlighted: false };
  });
};

